import { render, staticRenderFns } from "./whitelist_modal.vue?vue&type=template&id=6f2effb8&scoped=true&"
import script from "./whitelist_modal.vue?vue&type=script&lang=js&"
export * from "./whitelist_modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f2effb8",
  null
  
)

export default component.exports